import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_brandAll": "/product/brand/queryAll", // 查询所有品牌
}

// initial state
const state = {
    brandAll: [],
}

// getters
const getters = {
    getBrandAll: state => {
        return state.brandAll
    },
}

// actions
const actions = {
    getBrandAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_brandAll,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('PRODUCT_BRAND_ALL', res.data || []);
            } else {
                commit('PRODUCT_BRAND_ALL', []);
            }
        }).catch(err => {
            commit('PRODUCT_BRAND_ALL', []);
        })
    },
}


// mutations
const mutations = {
    PRODUCT_BRAND_ALL: (state, pageData) => {
        state.brandAll = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/brand.js